import { render, staticRenderFns } from "./bookdialog.vue?vue&type=template&id=fa002f9c&scoped=true"
import script from "./bookdialog.vue?vue&type=script&lang=js"
export * from "./bookdialog.vue?vue&type=script&lang=js"
import style0 from "./bookdialog.vue?vue&type=style&index=0&id=fa002f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa002f9c",
  null
  
)

export default component.exports